import {
  DateRange,
  defaultDateRangeFilters,
  Option,
  SplitBy,
} from "@intentsify/types";
import { isPopulatedArray } from "@intentsify/utils";
import {
  DateRangeFilter,
  Filter,
  FiltersContainer,
  FiltersContainerItem,
  FiltersContainerItemSize,
  SplitByFilter,
} from "components";
import { useParams } from "react-router-dom";
import { useAtomValue, useSetAtom } from "jotai";
import { useResetAtom } from "jotai/utils";
import {
  keywordsSplitByAtom,
  selectedTrendingKeywordsAtom,
  trendingKeywordsDateRangeAtom,
  trendingKeywordsOptionsStateAtom,
  trendingKeywordsStateSelector,
} from "../../TrendingKeywords.state";

const Filters = () => {
  const campaignId = Number(useParams<"campaignId">().campaignId);
  const {
    selectedKeywords,
    isLoading,
    keywordsOptions,
    selectedSplitBy,
    selectedDateRange,
  } = useAtomValue(trendingKeywordsStateSelector);
  const setSelectedKeywords = useSetAtom(selectedTrendingKeywordsAtom);
  const resetOptions = useResetAtom(trendingKeywordsOptionsStateAtom);
  const setSplitBy = useSetAtom(keywordsSplitByAtom);
  const setDateRange = useSetAtom(trendingKeywordsDateRangeAtom);

  const onSelectedKeywordsChange = (options: Array<Option<string>>) => {
    setSelectedKeywords({ campaignId, data: options });
  };

  const hasNoOptions = !isPopulatedArray(keywordsOptions);

  const items: FiltersContainerItem[] = [
    {
      component: (
        <Filter
          minW={"400px"}
          label={"Keywords"}
          options={keywordsOptions}
          isLoading={isLoading}
          isDisabled={isLoading || hasNoOptions}
          placeholder="Select keywords"
          onFilterValuesChange={(options: Option[]) => {
            onSelectedKeywordsChange(options as Array<Option<string>>);
          }}
          selected={selectedKeywords.data ?? []}
        />
      ),
      size: FiltersContainerItemSize.XL,
    },
    {
      component: (
        <DateRangeFilter<DateRange>
          isLoading={isLoading}
          isDisabled={isLoading}
          dateRange={selectedDateRange}
          options={defaultDateRangeFilters.dateRangeOptions}
          onChange={(value) => {
            resetOptions();
            setDateRange(value);
          }}
        />
      ),
    },
    {
      component: (
        <SplitByFilter<SplitBy>
          onChange={(value) => setSplitBy(value)}
          options={defaultDateRangeFilters.splitByOptions}
          value={selectedSplitBy}
          isLoading={isLoading}
          isDisabled={isLoading || hasNoOptions}
        />
      ),
    },
  ];

  return <FiltersContainer items={items} />;
};

export { Filters };
